export default function jumpToLinkedSite({ locale, siteName, url }) {
  window.location = url
}
